import styled from '@emotion/styled';
import BellIcon from 'src/assets/icons/BellIcon';
import { withConfig } from 'src/utils/withConfig';
import { ChatBubbleIcon, LightningBoltIcon } from '@radix-ui/react-icons';

export const NotificationsCentreWrapper = styled('div', { label: 'NotificationsCentreWrapper' })`
    display: flex;
    flex-direction: row;
`;

export const NotificationsWrapper = styled('div', { label: 'NotificationsWrapper' })`
    display: flex;
    cursor: pointer;
    margin: 0 16px;
    height: 100%;
    align-items: center;
`;

export const NotificationsBadge = withConfig(theme => styled('span', { label: 'NotificationsBadge' })`
    color: ${theme.header.txtColorQuaternary};
    background: ${theme.header.bgColorTertiary};
    border-radius: 12px;
    font-size: 14px;
    height: 24px;
    line-height: 1;
    margin-left: 7px;
    padding: 5px 8px;
    text-align: center;
`);

export const NotificationsList = styled('ul', { label: 'NotificationsList' })`
    position: absolute;
    top: 100%;
    right: 0;
    z-index: 2;
    background-color: #000;
    list-style: none;
    max-height: 500px;
    overflow-x: hidden;
    overflow-y: auto;
    margin: 0;
    padding: 0 7px 0 0;
`;

export const NotificationListItem = styled('li', { label: 'NotificationListItem' })`
    margin: 0 0 7px 7px;
`;

export const BellIconWrapper = withConfig(theme => styled(BellIcon, { label: 'BellIconWrapper' })`
    fill: ${theme.header.bgColorTertiary};
`);

export const ChatBubbleIconWrapper = withConfig(theme => styled(ChatBubbleIcon, { label: 'ChatBubbleIconWrapper' })`
    color: ${theme.header.bgColorTertiary};
`);

export const BetReferralIconWrapper = withConfig(theme => styled(LightningBoltIcon, { label: 'BetReferralIconWrapper' })`
    color: ${theme.header.bgColorTertiary};
`);
